import { z, ZodSchema } from "zod";
import { UseFormReturn } from "react-hook-form";
import { FieldType, Form } from "@shared/features/form/Form";
import PasswordRequirementsContainer from "../PasswordRequirements/PasswordRequirementsContainer";
import SignupAdditionalContent from "./SignupAdditionalContent";
import AuthActions from "../AuthActions/AuthActions";
import { twMerge } from "tailwind-merge";

export type Props = {
  className?: string;
  isWithAdditionalContent?: boolean;
  onSignup: () => Promise<void>;
  onSignupWithGoogle: () => Promise<void>;
  fields: FieldType[];
  form: UseFormReturn<z.infer<ZodSchema>>;
};

export function SignupForm({
  className,
  isWithAdditionalContent = true,
  onSignup,
  onSignupWithGoogle,
  fields,
  form,
}: Props) {
  const { isSubmitting, isLoading, isValid } = form.formState;

  return (
    <>
      <Form
        fields={fields}
        form={form}
        className={twMerge("px-8 py-8 flex-1", className)}
        innerClassName="justify-center"
      >
        <PasswordRequirementsContainer />
        {isWithAdditionalContent && <SignupAdditionalContent />}
      </Form>
      <AuthActions
        className={className}
        isSubmitting={isSubmitting}
        isLoading={isLoading}
        isValid={isValid}
        onSubmit={onSignup}
        onSubmitWithGoogle={onSignupWithGoogle}
        submitLabel="Sign up"
        googleLabel="Sign up with Google"
        googleButtonClassName="w-full"
        signupButtonClassName="w-full"
      />
    </>
  );
}

export default SignupForm;
